export default "__VITE_ASSET__DcXQwyCF__"